module.exports = __webpack_public_path__ + "img/1566998644.8bdb745f.jpg";